import React, { DetailedHTMLProps, HTMLAttributes, MouseEventHandler } from 'react';

export interface VoxelCardProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  bgClass?: string;
  shadowClass?: string;
  roundedClass?: string;
  className?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  disabled?: boolean;
  disableTooltip?: boolean;
  tooltip?: string;
}

export const VoxelCard: React.FC<VoxelCardProps> = ({
  children,
  className,
  bgClass = 'bg-white',
  shadowClass = 'shadow',
  roundedClass = 'rounded-xl',
  onClick,
  disabled,
  disableTooltip,
  tooltip,
}) => {
  return (
    <div
      onClick={disabled ? undefined : onClick}
      className={`
      ${!disabled && onClick ? 'cursor-pointer hover:bg-voxel-gray-100' : ''}
      ${disabled && onClick ? 'opacity-60' : ''}  
      ${bgClass} ${shadowClass} ${roundedClass}
      ${className}
      `}
    >
      {children}
    </div>
  );
};

export default VoxelCard;
